import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';
import {COACH_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_EMPTY} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';
import withRecordPopover from '../withRecordPopover';

import {NotCertifiedContent} from './NotCertifiedContent';
import reportPayload from './reportPayload';

export const NotCertifiedReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {},
}: ReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      // @ts-expect-error TS(2322): Type '{ title: any; description: any; contentProps... Remove this comment to see the full error message
      title={tt('title', 'Not Certified')}
      description={tt(
        'description',
        "Becoming Certified increases a Coach's knowledge and can help them be a better Coach. Reach out to encourage these Coaches to get Certified!",
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={NotCertifiedContent}
    />
  );
};

export default withHOC(
  withTranslation('report.notCertifiedReport'),
  withRecordPopover({
    reportPayload,
    popoverName: COACH_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_EMPTY,
    popoverContentProps: {},
  }),
)(NotCertifiedReport);
